import ServiceSlider, {SELECTORS as SERVICESLIDER_SELECTORS} from '../../../Components/Services/ServiceSlider';
import MobileServiceSlider, {
    SELECTORS as MOBILESERVICESLIDER_SELECTORS
} from '../../../Components/Services/MobileServiceSlider';
import Services, {SELECTORS as SERVICES_SELECTORS} from '../../../Components/Services/Services';

// SCSS
import '../../../Components/Services/_index.scss';

$(SERVICESLIDER_SELECTORS.root).each((i, serviceslider) => {
    new ServiceSlider(serviceslider);
});

$(MOBILESERVICESLIDER_SELECTORS.root).each((i, mobileserviceslider) => {
    new MobileServiceSlider(mobileserviceslider);
});

$(SERVICES_SELECTORS.root).each((i, service) => {
    new Services(service);
});